












































































import { AuthApiClient } from "@/api/auth_client";
import { AuthResponse } from "@/interfaces/auth";
import { Component, Vue } from "vue-property-decorator";
import CardComponent from "@/components/CardComponent.vue";

@Component({
  components: {
    CardComponent
  }
})
export default class ConfirmPassword extends Vue {
  private api = new AuthApiClient();

  private isLoading = false;
  private message = "";

  private form: any = {
    username: "",
    password: "",
    code: ""
  };

  mounted() {
    if (this.$store.state.userEmail) {
      this.form.username = this.$store.state.userEmail;
    }
  }

  submit() {
    this.isLoading = true;

    this.api
      .confirmResetPassword(
        this.form.username,
        this.form.password,
        this.form.code
      )
      .then((response: AuthResponse) => {
        if (response.ok) {
          this.message = "";

          this.$buefy.toast.open({
            message: this.$t("auth.confirmPassword.success"),
            type: "is-info",
            queue: false
          });

          this.$store.commit("basic", {
            key: "userEmail",
            value: this.form.username
          });

          this.$router.push("/login");
        }
      })
      .catch(error => {
        if (typeof error === "string") {
          this.message = this.$t(error);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
